import { h } from 'preact'
import TopicLabel from '../topic-list-view/TopicLabel'
import ClampLines from 'react-clamp-lines'
import ProductUpdateDateFormatter from './ProductUpdateDateFormatter'
// import TopicListLikeButton from '../topic-list-view/TopicListLikeButton'
// import TopicComments from '../topic-list-view/TopicComments'
// import TopicLastPost from '../topic-list-view/TopicLastPost'
import { ProductUpdateType } from './Types'
import htmlParser from '../utils/htmlParser'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props extends ProductUpdateType {
  isGuest: boolean,
  key: string,
  productAreasMapping: {
    [key:string]: string
  }
}

const ProductUpdateView = ({ isGuest, id, title, content, publicLabel, replyCount, createdAt, contentType, likes, featuredImage, productAreas, productAreasMapping }: Props) => {
  const strippedContent = htmlParser.stripHtml(content)

  return (
    <div className='product-update-view card-widget-wrapper'>
      <a href={`/product-updates/${id}`} className='product-update-url' />
      {
        featuredImage ? <img className='product-update-view_feature-image' src={featuredImage} /> : null
      }
      <div className='product-update-view_info'>
        <div className='product-update-view_info--metadata'>
          <TopicLabel topic={{ contentType: contentType, publicLabel: publicLabel }} />
          <span className='text--meta'> { ProductUpdateDateFormatter(createdAt) } </span>
        </div>
        <h4 className='card-widget-title product-update-view_info-title h3'>
          <a href={`/product-updates/${id}`}>{ title }</a>
        </h4>
        <p className='card-widget-text product-update-view_info-content'>
          <ClampLines id='product-update-view' lines={4} text={strippedContent || ''} buttons={false} />
        </p>
        {
          productAreas.length ? (
            <div className='product-update-view_product-areas'>
              <span className='text--meta'>
                <Phrase p='product.areas.related.products' />:
              </span>
              {
                productAreas.map(productAreaId => <span className='text--dot-underline product-area-item'>
                  { productAreasMapping[productAreaId] }
                </span>)
              }
            </div>
          ) : null
        }
        {/*TODO: Will be enabled soon so wil just comment out, not delete*/}
        {/*<div className='product-update-view_footer'>*/}
          {/*<TopicListLikeButton*/}
            {/*topic={{*/}
              {/*id: id,*/}
              {/*firstPost: {*/}
                {/*id: id*/}
              {/*},*/}
              {/*forum: {},*/}
              {/*numberOfLikes: likes*/}
            {/*}}*/}
            {/*isGuest={isGuest}*/}
          {/*/>*/}
          {/*<TopicComments*/}
            {/*lastPostUrl={'TBD'}*/}
            {/*numberOfReplies={replyCount}*/}
            {/*id={id}*/}
          {/*/>*/}
          {/*<TopicLastPost*/}
            {/*lastPostAuthor={{ ...lastContributor, ...{ name: lastContributor.username } }}*/}
            {/*lastPostUrl={`/product-updates/${id}`} // Until enabling replies*/}
            {/*lastPostRelativeCreationDate={lastActivityAt}*/}
          {/*/>*/}
        {/*</div>*/}
      </div>
    </div>
  )
}
export default ProductUpdateView
